import { Injectable } from '@angular/core';
import { tokenNotExpired } from 'angular2-jwt';
import { Router } from '@angular/router';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { CustomHttp } from '../shared/custom.http';

declare var moment: any;

@Injectable()
export class AuthService {
    constructor(private router: Router, private http: CustomHttp) {
    }
    errorMessage: string;
    login(username: string, password: string) {
        return this.http.login(username, password)

            .catch(this.handleError); // TODO: Display error message

    }
    isAuthenticated(token) {
        let user = this.getTokenClaims(token);
        if (user && moment().utc().isBefore(moment(user.exp, 'X'))) {
            return true;
        }
        return false;
    }

    getTokenClaims(token) {
        let user: any = {};
        if (typeof token !== 'undefined') {
            let encoded = token.split('.')[1];
            let userStr = this.urlBase64Decode(encoded).trim();
            user = JSON.parse(userStr);
        }
        return user;
    }

    urlBase64Decode(str) {
        let output = str.replace('-', '+').replace('_', '/');
        switch (output.length % 4) {
            case 0:
                break;
            case 2:
                output += '==';
                break;
            case 3:
                output += '=';
                break;
            default:
                return 'Illegal base64url string!';
        }
        return window.atob(output);
    }

    isUserAuthenticated() {
        let authenticated = false;
        const authToken = localStorage.getItem('id_token');
        if (authToken && authToken != null && authToken !== 'null') {
            authenticated = this.isAuthenticated(authToken);
        }
        return authenticated;
    }

    public logout() {
        // Remove token from localStorage
        localStorage.removeItem('id_token');
        localStorage.removeItem('is_data_api_user');

        // location.reload();
        this.router.navigate(['/login']);

    };
    public authenticated() {
        // Check if there's an unexpired JWT
        // It searches for an item in localStorage with key == 'id_token'
        return tokenNotExpired();
    };
    private handleError(error: any) {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.service.ts